import React from "react";
var __jsx = React.createElement;
import ContentItem from "@/pages/car-comparison/components/ContentItem";
import { CDN_LINK } from "@globalConfig";
import Accordion from "@componentsShared/Tailwind/Accordion/Accordion";
var CarInformation = function CarInformation(_ref) {
  var details = _ref.details,
    title = _ref.title;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "compare-info-section",
    className: "md:max-w-[767px] md:m-auto md:px-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3"
  }, /*#__PURE__*/React.createElement("p", {
    id: "compare-info-title",
    className: "text-sm font-bold text-gray-text text-start"
  }, title), /*#__PURE__*/React.createElement(Accordion, null, details.map(function (detail, groupIndex) {
    return /*#__PURE__*/React.createElement("div", {
      id: "compare-info-group-".concat(groupIndex),
      key: "accordion-".concat(groupIndex)
    }, /*#__PURE__*/React.createElement(Accordion.Item, {
      background: "bg-white",
      defaultOpen: groupIndex === 0
    }, /*#__PURE__*/React.createElement(Accordion.Title, {
      className: "text-sm font-bold text-gray-text text-start"
    }, detail === null || detail === void 0 ? void 0 : detail.title), /*#__PURE__*/React.createElement(Accordion.Body, {
      className: "flex flex-col gap-3 px-3"
    }, detail === null || detail === void 0 ? void 0 : detail.values.map(function (value, rowIndex) {
      var _value$values, _value$values2;
      var renderValue = function renderValue(node, carIndex) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, (typeof node === "string" || typeof node === "number") && /*#__PURE__*/React.createElement("span", {
          id: "compare-info-value-".concat(rowIndex, "-car-").concat(carIndex + 1),
          className: "text-gray-text text-sm font-semibold"
        }, node), typeof node === "boolean" && (node === true ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
          id: "compare-info-check-".concat(rowIndex, "-car-").concat(carIndex + 1),
          className: "w-4.5 h-4.5",
          src: CDN_LINK + '/assets/images/check-payment.svg',
          alt: "check"
        })) : node === false ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
          id: "compare-info-fail-".concat(rowIndex, "-car-").concat(carIndex + 1),
          className: "w-[18px] h-[18px]",
          src: CDN_LINK + '/assets/images/check-error-info-new.svg',
          alt: "check"
        })) : null));
      };
      return /*#__PURE__*/React.createElement(ContentItem, {
        id: "compare-info-row-".concat(rowIndex),
        titleId: "compare-info-row-label-".concat(rowIndex),
        rightId: "compare-info-row-right-".concat(rowIndex),
        leftId: "compare-info-row-left-".concat(rowIndex),
        titleClassName: "text-center",
        titleInside: true,
        key: (value === null || value === void 0 ? void 0 : value.title) + rowIndex,
        itemTitle: value === null || value === void 0 ? void 0 : value.title,
        rightNode: renderValue(value === null || value === void 0 ? void 0 : (_value$values = value.values) === null || _value$values === void 0 ? void 0 : _value$values[0], 0),
        leftNode: renderValue(value === null || value === void 0 ? void 0 : (_value$values2 = value.values) === null || _value$values2 === void 0 ? void 0 : _value$values2[1], 1)
      });
    }))));
  })))));
};
export default CarInformation;